import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

export type Usuario = z.infer<typeof zod.UsuarioSchema>
export type Filtros = z.infer<typeof zod.FiltroSchema>

export type UsuarioWithNome = Omit<Usuario, 'password'> & { nome: string }

const service = new ApiService<Usuario | UsuarioWithNome>('usuarios')
const filtros = new ApiService<Filtros>('usuarios/filtros')

export const usuarios = Object.assign(service, {
    filtros,
})
